export default {
  buttons: {
    create: 'Crear',
    update: 'Actualizar',
    cancel: 'Cancelar',
  },
  fields: {
    title: {
      label: 'Título',
      placeholder: 'Introduce el título',
    },
    description: {
      label: 'Descripción',
      placeholder: 'Introduce la descripción',
    },
    button_text: {
      label: 'Texto del botón',
      placeholder: 'Introduce el texto del botón',
    },
    button_url: {
      label: 'URL del botón',
      placeholder: 'https://example.com',
    },
    image: {
      label: 'Imagen',
    },
  },
  title: 'Crear publicación',
};
